import Home from './Home'
import Dispute from './Dispute'

const Liquidation = () => {}

Liquidation.Home = Home
Liquidation.Dispute = Dispute

export default Liquidation